<template>
    <Head title="Update Manufacturer"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Update Manufacturer - {{ manufacturer.name }}
            </h2>
        </template>
        <BreadCrumbs :items="items"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="submit" class="w-full">
                    <div class="mb-6 md:mb-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                            <div class="col-span-2 md:mb-4">
                                <admin-app-label>Name</admin-app-label>
                                <input-basic
                                    placeholder="Name"
                                    v-model="form.name"
                                    :error="errors['name']"
                                />
                                <input-error v-if="errors['name']">
                                    {{ errors.name }}
                                </input-error>
                            </div>
                            <div class="mb-6 md:mt-6 md:mb-4">
                                <input-checkbox v-model="form.featured">
                                    Featured
                                </input-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>New Image</admin-app-label>
                        <image-upload
                            :key="`Image`"
                            :label="`Image`"
                            v-model="form.image"
                            :error="errors['image']"
                        >
                        </image-upload>
                        <input-error v-if="errors['image']">
                            {{ errors.image }}
                        </input-error>

                        <div v-if="manufacturer.image" class="my-4">
                            <admin-app-label>Current Image</admin-app-label>
                            <img class="object-contain p-3 border-solid border-2 border-grey-200 rounded"
                                 :src="manufacturer.image"
                                 :alt="manufacturer.name"/>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="form.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['description']">
                            {{ errors.description }}
                        </input-error>
                    </div>
                    <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import {useForm, Head} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputCheckbox from "@/Components/Forms/Inputs/InputCheckbox";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    components: {
        SeoTags,
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError,
        ImageUpload,
        InputWysiwyg,
        InputCheckbox
    },
    props: {
        name: String,
        errors: Object,
        manufacturer: Object
    },
    data: function () {
        return {
            form: useForm({...this.manufacturer, image: null, _method: "put"}),
            items: [
                {title: "Manufacturers", path: "/admin/manufacturers"},
            ],
        };
    },
    mounted() {
        var valueToPush = {};
        valueToPush.title = "#" + this.manufacturer.id;
        valueToPush.path = "/admin/manufacturers/" + this.manufacturer.id + "/edit";

        this.items.push(valueToPush);
    },
    methods: {
        submit() {
            this.form.post(`/admin/manufacturers/${this.manufacturer.id}`);
        },
    }
};
</script>
